{
  "Validations": {
    "FileContent": "File does not contain data.",
    "FileSize": "Files must be smaller than 20 megabytes.",
    "FileType": "We only accept plain Word, JPG, PNG, and PDF file types. Please do not password-protect these files."
  }
}